module.exports = __webpack_public_path__ + "9a69ed6599857f72977cfd3e34aa5686.png";